function fireGroupAssignmentEvent(testGroup) {
  const exp_variant_string =
    testGroup === "A" ? "ABC-DELIVERY-A" : "ABC-DELIVERY-B";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "experience_impression",
    exp_variant_string,
  });
}

export function getTestGroup() {
  const currentAssignedTestGroup = localStorage.getItem("deliveryTestGroup");
  const currentDate = new Date();
  // 16.07.25 00:00 UTC
  const forcedGroupADate = new Date("2025-07-16T00:00:00Z");
  if (currentDate >= forcedGroupADate) {
    if (currentAssignedTestGroup === "B") {
      localStorage.setItem("deliveryTestGroup", "A");
      sessionStorage.removeItem("cartAttributesSaved");
    }
    return "A";
  }
  const testGroup = localStorage.getItem("deliveryTestGroup");
  if (testGroup !== null) {
    return testGroup;
  }
  const group = Math.random() < 0.5 ? "A" : "B";
  localStorage.setItem("deliveryTestGroup", group);
  fireGroupAssignmentEvent(group);
  return group;
}
